import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';



/*services*/
import { UtilsService } from './utils.service';




@Injectable({
	providedIn: 'root'
})



export class UsuarioService {

	APIKEY:string = environment.API_KEY;
	APIURL:string = environment.API_URL;
	token:string = null;
	IDDISPOSITVO:string = null;

	public usuario:any = null;



	constructor(private http:HttpClient, private router:Router, private utilsService:UtilsService) {
		this.getUsuarioActual();
	}


	async getUsuarioActual():Promise<any>{
		this.token = await this.utilsService.cargarToken();
		this.IDDISPOSITVO = await this.utilsService.cargarDispositivo();

		const url:string = `${this.APIURL}usuarios`;
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.IDDISPOSITVO,
			'Authorization': `Bearer ${this.token}`,
		})

		let params = new HttpParams;

		return new Promise( (resolve, reject) => {
			this.http.get(url, {headers, params}).subscribe( (res:any) => {
				this.usuario = res.data;
				resolve(res.data);
			},(err:any) => {
				console.error(err);
				this.utilsService.validarErrorQueryAPI(err);
				reject(err);
			})

		})

	}


	async getUsuarios(coleccion = null):Promise<any>{
		this.token = await this.utilsService.cargarToken();
		this.IDDISPOSITVO = await this.utilsService.cargarDispositivo();

		const url:string = (coleccion) ? `${this.APIURL}usuarios/${coleccion}` : `${this.APIURL}usuarios`;
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.IDDISPOSITVO,
			'Authorization': `Bearer ${this.token}`,
		})

		let params = new HttpParams;

		return new Promise( (resolve, reject) => {
			this.http.get(url, {headers, params}).subscribe( (res:any) => {
				resolve(res.data);
			},(err:any) => {
				console.error(err);
				this.utilsService.validarErrorQueryAPI(err);
				reject(err);
			})

		})

	}


	async postUsuarios(coleccion, data){
		this.token = await this.utilsService.cargarToken();
		this.IDDISPOSITVO = await this.utilsService.cargarDispositivo();
		const url:string = `${this.APIURL}usuarios/${coleccion}`;
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.IDDISPOSITVO,
			'Authorization': `Bearer ${this.token}`
		})
		let body = new HttpParams;
			body = data;
		return new Promise( (resolve, reject) => {
			this.http.post(url, body, {headers}).subscribe( (res:any) => {
				resolve(res.msg);
			},(err:any) => {
				this.utilsService.validarErrorQueryAPI(err);
				reject(err);
			})
		})
	}


	async cerrarSesion(){
		this.token = await this.utilsService.cargarToken();
		this.IDDISPOSITVO = await this.utilsService.cargarDispositivo();
		const url:string = `${this.APIURL}usuarios/logout`;
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.IDDISPOSITVO,
			'Authorization': `Bearer ${this.token}`
		})
		let body = new HttpParams;
		
		return new Promise( (resolve, reject) => {
			this.http.post(url, body, {headers}).subscribe( (res:any) => {
				resolve(res.msg);
			},(err:any) => {
				this.utilsService.validarErrorQueryAPI(err);
				reject(err);
			})
		})
	}





	async putUsuarios(coleccion, data){
		this.token = await this.utilsService.cargarToken();
		this.IDDISPOSITVO = await this.utilsService.cargarDispositivo();
		const url:string = `${this.APIURL}usuarios/${coleccion}`;
		const headers = new HttpHeaders({
			'Ls-Apikey': this.APIKEY,
			'Ls-Id': this.IDDISPOSITVO,
			'Authorization': `Bearer ${this.token}`
		})

		let body = new HttpParams;
			body = data;
		return new Promise( (resolve, reject) => {
			this.http.put(url, body, {headers}).subscribe( (res:any) => {
				resolve(res.msg);
			},(err:any) => {
				this.utilsService.validarErrorQueryAPI(err);
				reject(err);
			})
		})
	}


}
